<script context="module" lang="ts">
  import type { ClientUserStore } from 'shared/src';
  import { serverOrClientUserStorePageLoadFunction } from '$lib/stores/getUserStore';
  // export const load = userStorePageLoadFunction;
  export const load = serverOrClientUserStorePageLoadFunction;
</script>

<script lang="ts">
  import Lessons from '$lib/app/lessons/Lessons.svelte';

  import { fade } from 'svelte/transition';
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';
  import LoadingSpinner from '$lib/components/LoadingSpinner.svelte';

  export let clientUserStore: ClientUserStore | undefined = undefined;
</script>

<div class="lg:flex card space-x-8 card-margins card-padding" in:fade={{ duration: 250 }}>
  <PageTitle
    title="Lessons: Theory, Rhythm and Ear Training"
    description="Interactive lessons in music theory, rhythm and ear training."
    hideTitle
  />
  <h1 class="sr-only">Lessons</h1>
  {#if clientUserStore}
    <Lessons {clientUserStore} />
  {:else}
    <LoadingSpinner />
  {/if}
</div>
